/* eslint-disable */
import i from './r1.js'
import a from './c11.js'

var r = function () {
  function o(e) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, o);
    var t = (0,
      a.merge)({
        verbose: !0
      }, e);
    this.canvas = document.createElement("canvas"),
      this.canvas.width = 1,
      this.canvas.height = 1,
      document.body.appendChild(this.canvas);
    var n = this.canvas.getContext("webgl", {
      stencil: !0
    });
    n || (n = this.canvas.getContext("experimental-webgl", {
      stencil: !0
    }));
    var i = !!n;
    this.gl = n,
      this.report = {
        contextName: i,
        glVersion: n.getParameter(n.VERSION),
        shadingLanguageVersion: n.getParameter(n.SHADING_LANGUAGE_VERSION),
        vendor: n.getParameter(n.VENDOR),
        renderer: n.getParameter(n.RENDERER),
        unMaskedVendor: this.getUnmaskedInfo(n).vendor,
        unMaskedRenderer: this.getUnmaskedInfo(n).renderer,
        antialias: n.getContextAttributes().antialias ? "Available" : "Not available",
        angle: this.getAngle(n),
        majorPerformanceCaveat: this.getMajorPerformanceCaveat(i),
        maxColorBuffers: this.getMaxColorBuffers(n),
        redBits: n.getParameter(n.RED_BITS),
        greenBits: n.getParameter(n.GREEN_BITS),
        blueBits: n.getParameter(n.BLUE_BITS),
        alphaBits: n.getParameter(n.ALPHA_BITS),
        depthBits: n.getParameter(n.DEPTH_BITS),
        stencilBits: n.getParameter(n.STENCIL_BITS),
        maxRenderBufferSize: n.getParameter(n.MAX_RENDERBUFFER_SIZE),
        maxCombinedTextureImageUnits: n.getParameter(n.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
        maxCubeMapTextureSize: n.getParameter(n.MAX_CUBE_MAP_TEXTURE_SIZE),
        maxFragmentUniformVectors: n.getParameter(n.MAX_FRAGMENT_UNIFORM_VECTORS),
        maxTextureImageUnits: n.getParameter(n.MAX_TEXTURE_IMAGE_UNITS),
        maxTextureSize: n.getParameter(n.MAX_TEXTURE_SIZE),
        maxVaryingVectors: n.getParameter(n.MAX_VARYING_VECTORS),
        maxVertexAttributes: n.getParameter(n.MAX_VERTEX_ATTRIBS),
        maxVertexTextureImageUnits: n.getParameter(n.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
        maxVertexUniformVectors: n.getParameter(n.MAX_VERTEX_UNIFORM_VECTORS),
        aliasedLineWidthRange: n.getParameter(n.ALIASED_LINE_WIDTH_RANGE),
        aliasedPointSizeRange: n.getParameter(n.ALIASED_POINT_SIZE_RANGE),
        maxViewportDimensions: n.getParameter(n.MAX_VIEWPORT_DIMS),
        maxAnisotropy: this.getMaxAnisotropy(),
        vertexShaderBestPrecision: this.getBestFloatPrecision(n.VERTEX_SHADER),
        fragmentShaderBestPrecision: this.getBestFloatPrecision(n.FRAGMENT_SHADER),
        fragmentShaderFloatIntPrecision: this.getFloatIntPrecision(n),
        extensions: n.getSupportedExtensions(),
        draftExtensionsInstructions: this.getDraftExtensionsInstructions()
      },
      this.report.platform = navigator.platform,
      this.report.userAgent = navigator.userAgent,
      this.report.webglVersion = 1,
      this.canvas.parentNode.removeChild(this.canvas);
    var r = !(this.canvas = null);
    300 < this.report.aliasedPointSizeRange[1] || (r = !1),
      window.goodGPU = r,
      t.verbose && this.logReport()
  }
  return i(o, [{
    key: "logReport",
    value: function () { }
  }, {
    key: "describeRange",
    value: function (e) {
      return "[" + e[0] + ", " + e[1] + "]"
    }
  }, {
    key: "getMaxAnisotropy",
    value: function () {
      var e = this.gl.getExtension("EXT_texture_filter_anisotropic") || this.gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic") || this.gl.getExtension("MOZ_EXT_texture_filter_anisotropic");
      if (e) {
        var t = this.gl.getParameter(e.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        return 0 === t && (t = 2),
          t
      }
      return "n/a"
    }
  }, {
    key: "formatPower",
    value: function (e, t) {
      return t ? "" + Math.pow(2, e) : "2<sup>" + e + "</sup>"
    }
  }, {
    key: "getPrecisionDescription",
    value: function (e, t) {
      var n = t ? " bit mantissa" : "";
      return "[-" + this.formatPower(e.rangeMin, t) + ", " + this.formatPower(e.rangeMax, t) + "] (" + e.precision + n + ")"
    }
  }, {
    key: "getBestFloatPrecision",
    value: function (e) {
      var t = this.gl.getShaderPrecisionFormat(e, this.gl.HIGH_FLOAT)
        , n = this.gl.getShaderPrecisionFormat(e, this.gl.MEDIUM_FLOAT)
        , i = this.gl.getShaderPrecisionFormat(e, this.gl.LOW_FLOAT)
        , r = t;
      return 0 === t.precision && (r = n),
        "High: " + this.getPrecisionDescription(t, !0) + " | Medium: " + this.getPrecisionDescription(n, !0) + " | Low: " + this.getPrecisionDescription(i, !0) + '">' + this.getPrecisionDescription(r, !1)
    }
  }, {
    key: "getFloatIntPrecision",
    value: function (e) {
      var t = this.gl.getShaderPrecisionFormat(this.gl.FRAGMENT_SHADER, this.gl.HIGH_FLOAT)
        , n = 0 !== t.precision ? "highp/" : "mediump/";
      return n += 0 !== (t = this.gl.getShaderPrecisionFormat(this.gl.FRAGMENT_SHADER, this.gl.HIGH_INT)).rangeMax ? "highp" : "lowp"
    }
  }, {
    key: "isPowerOfTwo",
    value: function (e) {
      return 0 !== e && 0 == (e & e - 1)
    }
  }, {
    key: "getAngle",
    value: function (e) {
      var t = this.describeRange(this.gl.getParameter(this.gl.ALIASED_LINE_WIDTH_RANGE));
      return ("Win32" === navigator.platform || "Win64" === navigator.platform) && "Internet Explorer" !== this.gl.getParameter(this.gl.RENDERER) && "Microsoft Edge" !== this.gl.getParameter(this.gl.RENDERER) && t === this.describeRange([1, 1]) ? this.isPowerOfTwo(this.gl.getParameter(this.gl.MAX_VERTEX_UNIFORM_VECTORS)) && this.isPowerOfTwo(this.gl.getParameter(this.gl.MAX_FRAGMENT_UNIFORM_VECTORS)) ? "Yes, D3D11" : "Yes, D3D9" : "No"
    }
  }, {
    key: "getMajorPerformanceCaveat",
    value: function (e) {
      return this.canvas.parentNode || document.body.append(this.canavas),
        this.canvas.getContext(e, {
          failIfMajorPerformanceCaveat: !0
        }) ? void 0 === this.gl.getContextAttributes().failIfMajorPerformanceCaveat ? "Not implemented" : "No" : "Yes"
    }
  }, {
    key: "getDraftExtensionsInstructions",
    value: function () {
      return -1 !== navigator.userAgent.indexOf("Chrome") ? 'To see draft extensions in Chrome, browse to about:flags, enable the "Enable WebGL Draft Extensions" option, and relaunch.' : -1 !== navigator.userAgent.indexOf("Firefox") ? "To see draft extensions in Firefox, browse to about:config and set web.gl.enable-draft-extensions to true." : ""
    }
  }, {
    key: "getMaxColorBuffers",
    value: function (e) {
      var t = 1
        , n = this.gl.getExtension("WEBGL_draw_buffers");
      return null != n && (t = this.gl.getParameter(n.MAX_DRAW_BUFFERS_WEBGL)),
        t
    }
  }, {
    key: "getUnmaskedInfo",
    value: function (e) {
      var t = {
        renderer: "",
        vendor: ""
      }
        , n = this.gl.getExtension("WEBGL_debug_renderer_info");
      return null != n && (t.renderer = this.gl.getParameter(n.UNMASKED_RENDERER_WEBGL),
        t.vendor = this.gl.getParameter(n.UNMASKED_VENDOR_WEBGL)),
        t
    }
  }, {
    key: "showNull",
    value: function (e) {
      return null === e ? "n/a" : e
    }
  }]),
    o
}();
var t = { default: r }

export default t
